// extracted by mini-css-extract-plugin
export default {"heading":"XxhFiY","content":"lziPa8","card":"mqNx1L","image":"y3qfom","fresh-plan":"nASC5G","freshPlan":"nASC5G"};